/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  GetAdminsSuccess,
  GetAdminsError,
  GetAdminsPending,
  AdminsActionTypes,
  AdminsState,
  GetAdminError,
  GetAdminPending,
  CreateAdminPayload,
  CreateAdminPending,
  CreateAdminError,
  GetAdminSuccess,
  UpdateAdminPayload,
  UpdateAdminError,
  UpdateAdminPending,
  DeleteAdminError,
  DeleteAdminPending,
  GetValidPinCodeSuccess,
  GetValidPinCodePending,
  GetValidPinCodeError
} from './types';

// Actions
export const actions = {
  getAdmins: (): AdminsActionTypes => ({ type: types.GET_ADMINS.REQUEST }),
  getAdmin: (payload: { id: string }): AdminsActionTypes => ({
    type: types.GET_ADMIN.REQUEST,
    payload
  }),
  createAdmin: (payload: CreateAdminPayload): AdminsActionTypes => ({
    type: types.CREATE_ADMIN.REQUEST,
    payload
  }),
  updateAdmin: (payload: UpdateAdminPayload): AdminsActionTypes => ({
    type: types.UPDATE_ADMIN.REQUEST,
    payload
  }),
  deleteAdmin: (payload: { id: string }): AdminsActionTypes => ({
    type: types.DELETE_ADMIN.REQUEST,
    payload
  }),
  getValidPinCode: (): AdminsActionTypes => ({ type: types.GET_PINCODE.REQUEST }),
  resetPinCode: (): AdminsActionTypes => ({ type: types.RESET_PINCODE }),
  resetError: (): AdminsActionTypes => ({ type: types.RESET_ERROR }),
  resetAction: () => ({ type: types.RESET_ACTION })
};

// Initial State
export const initialState: AdminsState = {
  admins: [],
  admin: null,
  pinCode: '',
  action: {
    successful: false,
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (state: AdminsState = initialState, action: AdminsActionTypes): AdminsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_ADMINS.SUCCESS:
        draft.admins = (action as GetAdminsSuccess).payload;
        break;
      case types.GET_ADMIN.SUCCESS:
        draft.admin = (action as GetAdminSuccess).payload;
        break;
      case types.CREATE_ADMIN.SUCCESS:
      case types.UPDATE_ADMIN.SUCCESS:
      case types.DELETE_ADMIN.SUCCESS:
        draft.action.successful = true;
        break;
      case types.GET_PINCODE.SUCCESS:
        draft.pinCode = (action as GetValidPinCodeSuccess).payload;
        break;
      case types.GET_ADMINS.PENDING:
      case types.GET_ADMIN.PENDING:
      case types.GET_PINCODE.PENDING:
      case types.CREATE_ADMIN.PENDING:
      case types.UPDATE_ADMIN.PENDING:
      case types.DELETE_ADMIN.PENDING:
        draft.action.pending = (
          action as
            | GetAdminsPending
            | GetAdminPending
            | GetValidPinCodePending
            | CreateAdminPending
            | UpdateAdminPending
            | DeleteAdminPending
        ).payload;
        break;
      case types.GET_ADMINS.ERROR:
      case types.GET_ADMIN.ERROR:
      case types.GET_PINCODE.ERROR:
      case types.CREATE_ADMIN.ERROR:
      case types.UPDATE_ADMIN.ERROR:
      case types.DELETE_ADMIN.ERROR:
        draft.action.error = (
          action as
            | GetAdminsError
            | GetAdminError
            | GetValidPinCodeError
            | CreateAdminError
            | UpdateAdminError
            | DeleteAdminError
        ).payload;
        break;
      case types.RESET_PINCODE:
        draft.pinCode = initialState.pinCode;
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
    }
  });
};
